// 新聞列表
import NewsComponent from "../basic/NewsComponent"; /// 新聞元件
import NewsSkeltonComponent from "../skelton/NewsSkeltonComponent";

const NewsList = ({ newsList, t, loading }) => {
  return (
    <div
      className="flex justify-between flex-grow-1 flex-wrap gap-x-[20px] gap-y-[50px] ulg:gap-y-[36px] usm:!gap-y-[30px]
        [&>*]:w-[calc((100%-20px)/2)] umd:flex-col umd:[&>*]:w-full"
    >
      {/* loading skelton */}
      {loading
        ? new Array(10)
            .fill(0)
            .map((_, i) => (
              <NewsSkeltonComponent key={i + "news-skelton-list" + i} />
            ))
        : newsList?.map((news, i) => (
            // 新聞列表
            <NewsComponent
              key={i + "news-list" + news?.id + i}
              t={t}
              news={news}
              location="list"
            />
          ))}

      {loading}
    </div>
  );
};

export default NewsList;
